import React from 'react';
import styled from '@emotion/styled';
import ConfirmationDialog from '../../../components/structure/ConfirmationDialog';
import WarningConfirmation from '../../../components/general/WarningConfirmation';

interface RemoveApplicationFeatureFlagModalProps {
    featureFlag: FeatureFlagModel;
    isLoading: boolean;
    errors?: string[];
    onClose: () => void;
    onConfirm: () => void;
}

const RemoveApplicationFeatureFlagModal: React.FC<RemoveApplicationFeatureFlagModalProps> = (props) => (
    <ConfirmationDialog
        title="Remove Feature Flag"
        deleteText="Yes, Remove"
        isLoading={props.isLoading}
        onClose={props.onClose}
        onConfirm={props.onConfirm}
    >
        <WarningConfirmation
            text={`Remove the "${props.featureFlag.name}" feature flag from this application? This takes effect immediately and permanently deletes its application-specific settings.`}
        />
        {props.errors?.length > 0 &&
            <ErrorMessage role="alert">
                {props.errors.join(' ')}
            </ErrorMessage>
        }
    </ConfirmationDialog>
);

const ErrorMessage = styled.p`
    margin: -40px 48px 24px;
    color: #c62828;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
`;

export default RemoveApplicationFeatureFlagModal;
